import { useEffect } from 'react';

import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';

import useAuth from 'src/app/hooks/useAuth';
import { useSegmentEvent } from 'src/app/hooks/useSegmentEvent';
import { login } from 'src/app/router/paths';

import Spinner from '../../Elements/Spinner';

export const Logout = () => {
  const { logout, isLoggedIn, loggedInUser } = useAuth();
  const { replace } = useHistory();
  const location = useLocation();
  const locationState = location.state ? (location.state as { [key: string]: string }) : {};
  const { loginQs, isGlobal } = locationState;

  useSegmentEvent('logoutSuccessful', {
    shouldTrackOnMount: true,
    payload: { customer_initiated: location.search.includes('initiated') },
  });

  useEffect(() => {
    const logoutAndRedirect = async () => {
      if (isLoggedIn) {
        await logout({ global: isGlobal === 'true' }); // Wait to clear state first before redirecting.
      }
    };
    logoutAndRedirect();
  }, [isLoggedIn, logout, isGlobal]);

  useEffect(() => {
    // Wait for the login variables to resolve.
    if (isLoggedIn === undefined || loggedInUser === undefined) {
      return;
    }

    if (isLoggedIn === false && loggedInUser === null) {
      replace(`${login.toPath()}${loginQs ? `${loginQs}` : ''}`, location.state);
    }
  }, [isLoggedIn, loginQs, loggedInUser, replace, location.state]);

  return <Spinner centered />;
};
